export default __webpack_public_path__ + "static/media/couplecarpetstairs.a648d4c7.jpg";